import Vue from "vue";
import { hexToRgba } from "@/components/PulseInsights/pulseTracks";
export default Vue.extend({
    name: "PulseScoreGauge",
    props: {
        score: { type: Number, default: null },
        color: { type: String, default: "#2f9e57" },
        scoreLabel: { type: String, default: "Score" },
        bandLabel: { type: String, default: null },
        // change since previous check-in; null when there is no prior score
        delta: { type: Number, default: null },
        assessed: { type: Boolean, default: false },
        // when set, overrides the auto-generated "improved/dropped" subtitle
        customSubtitle: { type: String, default: null },
        // when true, the score becomes clickable and emits "score-click"
        clickable: { type: Boolean, default: false },
    },
    methods: {
        onScoreClick() {
            if (this.clickable && this.assessed)
                this.$emit("score-click");
        },
    },
    data() {
        return {
            radius: 85,
        };
    },
    computed: {
        circumference() {
            return 2 * Math.PI * this.radius;
        },
        progressOffset() {
            const clamped = Math.max(0, Math.min(100, this.score || 0));
            return this.circumference * (1 - clamped / 100);
        },
        deltaText() {
            if (this.delta === null)
                return "";
            return `${this.delta > 0 ? "+" : ""}${this.delta}`;
        },
        deltaClass() {
            if (!this.delta)
                return "neutral";
            return this.delta > 0 ? "positive" : "negative";
        },
        deltaIcon() {
            if (!this.delta)
                return "fa-minus";
            return this.delta > 0 ? "fa-arrow-up" : "fa-arrow-down";
        },
        bandStyle() {
            if (!this.assessed)
                return null;
            return {
                color: this.color,
                borderColor: hexToRgba(this.color, 0.4),
                backgroundColor: hexToRgba(this.color, 0.12),
            };
        },
        subtitle() {
            if (this.customSubtitle)
                return this.customSubtitle;
            if (!this.assessed)
                return "Complete an assessment to see your results.";
            if (this.delta === null)
                return "This is your first check-in.";
            if (this.delta > 0)
                return "Your score improved since last check-in.";
            if (this.delta < 0)
                return "Your score dropped since last check-in.";
            return "Your score is unchanged since last check-in.";
        },
    },
});
